











































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { constants } from 'http2';

@Component
export default class MobileNavigationDrawer extends Vue {
    @Prop({ default: false }) public show!: boolean;

    public navigationList: any[] = [
        {
            key: 1,
            name: 'Event List',
            path: '/event',
        },
        {
          key: 2,
          name: 'Log out',
          path: '/logout'
        }
    ];


    public updateShow(isShow: boolean) {
        this.$emit('update:show', isShow);
    }

    public onNavigationDrawerClick(path: string) {
        this.$emit('update:show', false);
        if (path === '/logout') {
          this.$store.commit('MUTATE_AUTH_IS_LOGIN', false);
          this.$store.commit('MUTATE_AUTH_NAME', '');
          this.$store.commit('MUTATE_AUTH_EMAIL', '');
          this.$store.commit('MUTATE_AUTH_TOKEN', '');
          this.$router.replace('/');
        } else {
          this.$router.push(path);
        }
    }
    get getHeaderStyle(): any {
        return this.$store.getters.getHeaderStyle;
    }
    get email() {
      return this.$store.getters.getEmail;
    }

}
